module.exports = __webpack_public_path__ + "static/media/profit-report.6c92fc5e.svg";